module.exports = __webpack_public_path__ + "static/media/google.1811dc00.jpeg";